import { callApi } from "@src/utils/api-client";
import { isInSalesforce } from "@src/utils/canvas-config";
import { getFailureTypeForHttpStatus } from "@src/utils/failure-taxonomy";
import ClientLogsService from "./client-logs.service";
import { buildAddressSearchConfig } from "./configs/address-search.config";

export const fetchAddressSearch = async (
  zipcode: string,
  user_uuid?: string,
  role?: string,
  testRecord?: boolean,
) => {
  try {
    // Resolve the role once: prefer the caller-provided role, otherwise detect
    // the Canvas iframe and default to 'patient navigator' inside Salesforce.
    let resolvedRole = role;
    if (!resolvedRole) {
      try {
        if (isInSalesforce()) {
          resolvedRole = "patient navigator";
        }
      } catch {
        // ignore detection errors
      }
    }

    const { data, response } = await callApi(
      buildAddressSearchConfig(zipcode, user_uuid, resolvedRole, testRecord),
    );

    if (!response.ok) {
      // Log the API error
      ClientLogsService.logError(
        user_uuid || "unknown",
        "address-search.service.fetchAddressSearch",
        "Address search failed",
        new Error(data?.message || "Failed to fetch address data."),
        {
          errorType: getFailureTypeForHttpStatus(response.status),
          dependencyName: "AddressSearchAPI",
          functionName: "fetchAddressSearch",
        },
      );
      return { error: data?.message || "Error fetching address data." };
    }
    return data;
  } catch (err: any) {
    const errorMessage = err instanceof Error ? err.message : "Unknown error occurred";

    // Log the client-side error
    ClientLogsService.logError(
      user_uuid || "unknown",
      "address-search.service.fetchAddressSearch",
      "Address search failed",
      err instanceof Error ? err : new Error(errorMessage),
      {
        errorType: "DependencyFailure",
        dependencyName: "AddressSearchAPI",
        functionName: "fetchAddressSearch",
      },
    );

    return {
      error: errorMessage,
    };
  }
};

export default { fetchAddressSearch };
